import React from 'react';
import PropTypes from 'prop-types';
import { educationLevels } from '../../copy/educationLevels';

const DoctorateDegreeIcon = ({ color, height, width }) => {
  return (
    <svg
      height={height}
      width={width}
      fill={color}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 1000 1000"
      role="img"
    >
      <title>{educationLevels().level9.label}</title>
      <g>
        <path
          d="M327.3,369.9l-7.2,37.6c0,1.4,0,2.9,1.4,4.3c1.4,0,1.4,1.4,2.9,1.4c1.4,0,1.4,0,2.9,0l34.7-17.3l34.7,17.3
		c1.4,1.4,2.9,0,4.3,0c1.4-1.4,2.9-2.9,1.4-4.3l-7.2-37.6l27.5-27.5c1.4-1.4,1.4-2.9,1.4-4.3s-1.4-2.9-4.3-2.9l-39-5.8l-17.3-34.7
		c-1.4-2.9-7.2-2.9-8.7,0l-17.3,34.7l-39,5.8c-1.4,0-2.9,1.4-4.3,2.9c0,1.4,0,4.3,1.4,4.3L327.3,369.9z"
        />
        <path
          d="M879.3,28.9h-20.2l0,0C850.4,11.6,833,0,811.4,0H192.9c-20.2,0-39,11.6-47.7,28.9c-1.4,0-2.9-1.4-4.3-1.4h-20.2
		c-17.3,0-31.8,14.5-31.8,31.8v91c0,17.3,14.5,31.8,31.8,31.8h20.2c1.4,0,2.9,0,4.3-1.4c7.2,14.5,20.2,24.6,37.6,27.5v583.8
		c-15.9,2.9-30.3,14.5-37.6,27.5c-1.4,0-2.9-1.4-4.3-1.4h-20.2c-17.3,0-31.8,14.5-31.8,31.8v91c0,17.3,14.5,31.8,31.8,31.8h20.2
		c1.4,0,2.9,0,4.3-1.4c8.7,17.3,26,28.9,47.7,28.9h618.5c20.2,0,37.6-11.6,47.7-28.9l0,0h20.2c17.3,0,31.8-14.5,31.8-31.8v-91
		c0-17.3-14.5-31.8-31.8-31.8h-20.2l0,0c-7.2-14.5-20.2-24.6-36.1-27.5V212.4c15.9-2.9,28.9-13,36.1-27.5l0,0h20.2
		c17.3,0,31.8-14.5,31.8-31.8v-91C912.5,43.4,898.1,28.9,879.3,28.9z M117.7,153.2v-91c0-1.4,1.4-2.9,2.9-2.9H138v98.3h-17.3
		C119.2,156.1,117.7,154.6,117.7,153.2z M792.6,213.9v580.9H211.7V213.9H792.6z M117.7,946.5v-91c0-1.4,1.4-2.9,2.9-2.9H138v98.3
		h-17.3C119.2,950.9,117.7,948,117.7,946.5z M883.6,855.5v91c0,1.4-1.4,2.9-2.9,2.9h-14.5v-98.3h14.5
		C880.7,852.6,883.6,854,883.6,855.5z M835.9,848.3v105.5c0,13-11.6,24.6-24.6,24.6H192.9c-13,0-24.6-11.6-24.6-24.6V848.3
		c0-13,11.6-24.6,24.6-24.6h618.5C825.8,823.7,835.9,835.3,835.9,848.3z M835.9,160.4c0,13-11.6,24.6-24.6,24.6H192.9
		c-13,0-24.6-11.6-24.6-24.6V54.9c0-13,11.6-24.6,24.6-24.6h618.5c13,0,24.6,11.6,24.6,24.6V160.4z M883.6,153.2
		c0,1.4-1.4,2.9-2.9,2.9h-14.5V57.8h14.5c1.4,0,2.9,1.4,2.9,2.9V153.2z"
        />
        <path
          d="M724.7,510.1H545.5c-8.7,0-14.5,5.8-14.5,14.5c0,8.7,5.8,14.5,14.5,14.5h179.2c8.7,0,14.5-5.8,14.5-14.5
		C739.1,515.9,733.3,510.1,724.7,510.1z"
        />
        <path
          d="M724.7,602.6H545.5c-8.7,0-14.5,5.8-14.5,14.5c0,8.7,5.8,14.5,14.5,14.5h179.2c8.7,0,14.5-5.8,14.5-14.5
		C739.1,608.4,733.3,602.6,724.7,602.6z"
        />
        <path
          d="M724.7,695.1H545.5c-8.7,0-14.5,5.8-14.5,14.5s5.8,14.5,14.5,14.5h179.2c8.7,0,14.5-5.8,14.5-14.5S733.3,695.1,724.7,695.1
		z"
        />
        <path
          d="M281,539h179.2c8.7,0,14.5-5.8,14.5-14.5c0-8.7-5.8-14.5-14.5-14.5H281c-8.7,0-14.5,5.8-14.5,14.5
		C266.6,533.2,272.3,539,281,539z"
        />
        <path
          d="M281,631.5h179.2c8.7,0,14.5-5.8,14.5-14.5c0-8.7-5.8-14.5-14.5-14.5H281c-8.7,0-14.5,5.8-14.5,14.5
		C266.6,625.7,272.3,631.5,281,631.5z"
        />
        <path d="M460.2,695.1H281c-8.7,0-14.5,5.8-14.5,14.5S272.3,724,281,724h179.2c8.7,0,14.5-5.8,14.5-14.5S468.9,695.1,460.2,695.1z" />
        <path
          d="M541.1,439.3h185c8.7,0,14.5-5.8,14.5-14.5V280.3c0-8.7-5.8-14.5-14.5-14.5h-185c-8.7,0-14.5,5.8-14.5,14.5v144.5
		C526.7,432.1,532.5,439.3,541.1,439.3z M555.6,294.8h156.1v115.6H555.6V294.8z"
        />
      </g>
    </svg>
  );
};

export default DoctorateDegreeIcon;

DoctorateDegreeIcon.propTypes = {
  color: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
};
